import { GetFormattedNumber } from "../../../../../Helpers/Formatters";
import { EsignerRole } from "../../../../../Common/Constant";
import { getEsignPrefillData, isMissingPhoneOrEmail, setPhoneAndEmail } from "./eSignerFunctions";
import { insurancePolicyTypes } from "../../../../ABLTC/SubComponents/SelectOptions";

const getPiInfo = (formState) => {
  const { insuredBasicInfo, retrieveAccount } = formState.pages;
  const isSurvivorshipPolicy = retrieveAccount && retrieveAccount.insurancePolicyType === insurancePolicyTypes.SURVIVORSHIP;

  // if owner is PI, don't add new PI signer
  if ((retrieveAccount.isProposedInsured === true || retrieveAccount.isProposedInsured.toLowerCase() === 'true') && !isSurvivorshipPolicy
    || (isSurvivorshipPolicy && retrieveAccount.insured !== 'Other'))
    return null;

  let emailList = [{
    label: insuredBasicInfo.proposedInsuredEmail, value: insuredBasicInfo.proposedInsuredEmail
  }];
  let phoneList = [{
    label: GetFormattedNumber(insuredBasicInfo.proposedInsuredPhone), value: insuredBasicInfo.proposedInsuredPhone
  }];

  const { phoneVal, emailVal } = setPhoneAndEmail(emailList, phoneList);
  const { prefillAuthentication } = getEsignPrefillData(EsignerRole.PROPOSED_INSURED, formState);

  return {
    firstName: insuredBasicInfo.proposedInsuredFirstName,
    lastName: insuredBasicInfo.proposedInsuredLastName,
    email: emailVal,
    phone: phoneVal,
    emailList: emailList,
    phoneList: phoneList,
    missingContact: isMissingPhoneOrEmail(emailList, phoneList),
    role: EsignerRole.PROPOSED_INSURED,
    authentication: prefillAuthentication || '',
  };
}

export default getPiInfo;


// WEBPACK FOOTER //
// ./src/components/Product/SharedComponents/ESign/Helpers/ESigner/getPiInfo.js